import "./TimeTrackerOverviewTotal.css";
import React, { useMemo } from "react";

import Clock from "../../../images/icons/clock.svg";
import Billable from "../../../images/icons/billable.svg";
import NonBillable from "../../../images/icons/non-billable.svg";

// Component for time display with fade-in
const AnimatedTimeDisplay = ({ timeString, isLoading }) => {
  if (isLoading) {
    return <div className="total-time-skeleton" />;
  }
  return (
    <time style={{ animation: 'time-fade-in 0.4s ease both' }}>
      {timeString}
    </time>
  );
};

const formatDuration = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

const TimeTrackerOverviewTotal = (props) => {
  const hour = props.TotalHours;

  const formattedDuration = useMemo(() => {
    const sum = hour.reduce((total, item) => total + item.duration, 0);
    return formatDuration(sum);
  }, [hour]);

  const billableHours = useMemo(() => {
    const sum = hour.reduce((total, item) => total + (item?.project?.is_billable === true ? item.duration : 0), 0);
    return formatDuration(sum);
  }, [hour]);

  const nonBillableHours = useMemo(() => {
    const sum = hour.reduce((total, item) => total + (item?.project?.is_billable === false ? item.duration : 0), 0);
    return formatDuration(sum);
  }, [hour]);


  return (
    <div className="total-overview-outer">
      <div className="inner-overview-hours">
        <div className="overview-item">
          <div className="overview-title-outer">
            {/* {props.isLoading ? (
              <>
                <div
                  className="overview-title"
                  style={{
                    width: "120px",
                    height: "22px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                    margin: 0,
                  }}
                />
                <div
                  className="overview-icon"
                  style={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </>
            ) : (
              <> */}
            <div className="overview-title">Total Hours</div>
            <div className="overview-icon">
              <img src={Clock} alt="cLock" />
            </div>
            {/* </>
            )} */}
          </div>
          <div className="overview-rice">
            <AnimatedTimeDisplay timeString={formattedDuration} isLoading={props.isLoading} />
          </div>
        </div>
        <div className="overview-item">
          <div className="overview-title-outer">
            {/* {props.isLoading ? (
              <>
                <div
                  className="overview-title"
                  style={{
                    width: "130px",
                    height: "22px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                    margin: 0,
                  }}
                />
                <div
                  className="overview-icon"
                  style={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </>
            ) : (
              <> */}
            <div className="overview-title">Total Billable</div>
            <div className="overview-icon">
              <img src={Billable} alt="Billable" />
            </div>
            {/* </>
            )} */}
          </div>
          <div className="overview-rice">
            <AnimatedTimeDisplay timeString={billableHours} isLoading={props.isLoading} />
          </div>
        </div>
        <div className="overview-item">
          <div className="overview-title-outer">
            {/* {props.isLoading ? (
              <>
                <div
                  className="overview-title"
                  style={{
                    width: "160px",
                    height: "22px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                    margin: 0,
                  }}
                />
                <div
                  className="overview-icon"
                  style={{
                    width: "24px",
                    height: "24px",
                    backgroundColor: "#e5e7eb",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              </>
            ) : (
              <> */}
            <div className="overview-title">Total Non-Billable</div>
            <div className="overview-icon">
              <img src={NonBillable} alt="cLock" />
            </div>
            {/* </>
            )} */}
          </div>
          <div className="overview-rice">
            <AnimatedTimeDisplay timeString={nonBillableHours} isLoading={props.isLoading} />
          </div>
        </div>
      </div>
      {/* Pulse animation style */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default TimeTrackerOverviewTotal;